/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Main Index file
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import App from './App';

// Importing Store file (Redux)
import Store from './Store';

// Importing Gobal CSS file
import './resources/css/style.css';

// Global theme
const theme = createMuiTheme({
  palette: {
    primary: { main: '#e36e39' },
    secondary: { main: '#2196f3' }
  },
  typography: { useNextVariants: true }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={Store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);
